import React, { useEffect, useState } from 'react'
import axios from 'axios'// npm i react-axios  => // npm install axios
import Pagination1 from './Pagination1'
import Posts from './Posts';

const Players1 = () => {

    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage] = useState(15);

    useEffect(() => {
        const fetchPosts = async () => {
            setLoading(true);
            const res = await axios.get('https://api-football-v1.p.rapidapi.com/v3/players/squads', {
                headers: {
                    "X-RapidAPI-Key" : "ed5f66bf66msh3195b0687e916c5p11ad30jsndeaa1680f030",
                    "X-RapidAPI-Host": "api-football-v1.p.rapidapi.com"
                },
                params: {
                    team: '33'
                }
    
            });
            // console.log(res.data.response); 
            setPosts(res.data.response[0].players);
            setLoading(false);
        }
        fetchPosts();
    },[]);

    console.log(posts);

    //Get current posts
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost)

    // Change Page
    const paginate = (pageNumber) => setCurrentPage(pageNumber)

  return (
    <div className='container-fluid min-vh-100 mt-5'>
        <div className='container text-center'>
            <h1 className='players-title mb-5'>Squad</h1>
            
                <Posts posts={currentPosts} loading={loading}/>
                <Pagination1 postsPerPage = { postsPerPage } totalPosts={posts.length} paginate={paginate}/>
            
        </div>
 
</div>
  )
}

export default Players1